import { APIClient, ILink, WithLinks } from '@autopylot-internal/autopylot-api-client';

const mediaType = 'application/json';
const headers = { accept: mediaType, 'content-type': mediaType };

export type ISO8601 = string;

export interface IAttachment {
    fileName: string;
    url: string;
    contentType: string;
}

export interface INoteRequest {
    noteId: string;
    title: string;
    html: string;
    attachments: IAttachment[];
    otherAttributes: {};
    version?: number;
}

export interface INoteResponse extends INoteRequest {
    createdAt: ISO8601
    createdBy: string;
    updatedAt: ISO8601
    updatedBy: string;
    version: number;
    links: any;
}

export type INote = INoteRequest & Partial<INoteResponse>;

export class NotesClient {
    static inject = () => [APIClient];
    constructor(private apiClient: APIClient){}

    getNotes = async (parentLink: ILink): Promise<WithLinks<INoteResponse>[]> => {
        const notes = await this.apiClient.get(parentLink, mediaType);
        return notes;
    };

    addNote = async ({ parentLink, note }: { parentLink: ILink; note: INoteRequest }): Promise<WithLinks<INoteResponse>> => {
        return await this.apiClient.post(parentLink, note, headers);
    };

    updateNote = async (note: WithLinks<INoteRequest>) => {
        return await this.apiClient.put(note.links.self, note, headers);
    };

    deleteNote = async (note: WithLinks<INoteRequest>) => {
        await this.apiClient.delete(note.links.delete, { version: note.version });
    };
}
